import { baseUrl, handleResponse, handleError, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "Utilization";

export function getUtilization() {
  return fetch(apiUrl, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getUtilization_Admin(userId) {
  return fetch(apiUrl + "/admin/" + userId, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getUtilization_Manager(userId) {
  return fetch(apiUrl + "/manager/" + userId, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}
